module.exports = "/templates/target.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/target.html
// module id = 460
// module chunks = 0